import React from "react";
import "../../css/service2.css";
import CircleSlideshow from "./effects/CircleSlideShow";

function ServiceSection2() {
  // Array of slide content
  const slides = [
    "Tu sector industrial",
    "Visión de expansión a largo plazo",
    "Nivel de preparación para exportar",
    "Presupuesto disponible",
    "Objetivos a corto plazo",
    "Mercados de interés"
  ];

  return (
    <div className="packages" id="paquetes">
      <div className="container-fluid">
        <div className="section-title">
          <p className="title-package">Paquetes Personalizados</p>
          <p className="subtitle1">Nuestros paquetes de consultoría no tienen precios fijos, porque cada negocio es distinto. <br></br>Diseñamos propuestas personalizadas basadas en:</p>
        </div>

        <div className="packages-content">
          <p  className="subtitle2">Factores que consideramos</p>

          {/* Using the slideshow component */}
          <CircleSlideshow slides={slides} />

          <p  className="subtitle2">Paquetes</p>
          <div className="package-icons">
            <a href="https://wa.me/51924654344?text=Hola Voila Consulting, estoy interesado en el paquete de Exploración de Mercados, me podrias dar detalles de ello" target="_blank" rel="noopener noreferrer" className="package-icon">
              <i className="fas fa-search"></i>
              <p>Exploración de Mercados</p>
            </a>
            <a href="https://wa.me/51924654344?text=Hola Voila Consulting, estoy interesado en el paquete de Preparación para Exportar, me podrias dar detalles de ello" target="_blank" rel="noopener noreferrer" className="package-icon">
              <i className="fas fa-rocket"></i>
              <p>Preparación para Exportar</p>
            </a>
            <a href="https://wa.me/51924654344?text=Hola Voila Consulting, estoy interesado en el paquete de Expansión y Optimización, me podrias dar detalles de ello" target="_blank" rel="noopener noreferrer" className="package-icon">
              <i className="fas fa-expand-alt"></i>
              <p>Expansión y Optimización</p>
            </a>
           
          </div>

          <p className="highlight">
            <i className="fas fa-lightbulb"></i> <strong>Agenda una evaluación gratuita y juntos crearemos el plan ideal para tu negocio.</strong>
          </p>
          <a href="https://wa.me/51924654344?text=Hola Voila Consulting, estoy interesado en crear un paquete personalizado con sus servicios, me podrias dar detalle de ello." target="_blank" rel="noopener noreferrer" className="btn package-btn">Solicitar Propuesta Personalizada</a>
        </div>
      </div>
    </div>
  );
}

export default ServiceSection2;